export default __webpack_public_path__ + "static/barlow-v4-latin-300-dc90bd7ef8d8b95c8a5d3f8520f5d2bc.woff";